import * as React from "react";
import { useState } from "react";
import { sendPostRequest } from "../../Client/index.js";
import loginBackground from "../../Assets/Images/login-background.png";
import logo from "../../Assets/Images/ballerz-logo-white.png";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function NoUser() {
  const navigate = useNavigate();

  const location = useLocation();
  const email = location.state?.email;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");

  const handleSubmit = async () => {
    if (!firstName || !lastName || !username) {
      alert("Please fill in all fields.");
      return;
    }

    const res = await sendPostRequest(`user/add/nobooking`, {
      firstname: firstName,
      lastname: lastName,
      username: username,
      email: email,
    });

    if (res?.status === "username_taken") {
      alert(`Error: ${res?.reason}`);
      return;
    }

    localStorage.setItem("ballerz-user", JSON.stringify(res));
    navigate("/", {});
  };

  return (
    <div
      className="relative flex items-center justify-center px-8 py-16 bg-cover bg-center text-white w-screen h-screen"
      style={{
        backgroundImage: `url(${loginBackground})`,
      }}
    >
      <img
        src={logo}
        alt="Top Left"
        className="absolute top-10 left-1/2 sm:top-20 sm:left-20 transform -translate-x-1/2 sm:translate-x-10 w-40 h-auto"
      />

      <div className="flex flex-col ">
        <h1 className="text-3xl mt-6 text-center Kallisto_Bold">
          You don't appear to have visited Ballerz before
        </h1>

        <h3 className="text-xl mt-6 text-center Kallisto_Bold text-gray-300">
          Create your account below to access the Bootroom
        </h3>

        <div className="mt-6 flex flex-col items-center w-full">
          <div className="flex gap-4 w-[90%] max-w-[800px] mb-4">
            <input
              type="text"
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="bg-[#1f2644] rounded-md px-6 py-4 text-white text-lg w-1/2 font-kallisto focus:outline-none focus:ring-2 Kallisto_Bold"
            />
            <input
              type="text"
              placeholder="Last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="bg-[#1f2644] rounded-md px-6 py-4 text-white text-lg w-1/2 font-kallisto focus:outline-none focus:ring-2 Kallisto_Bold"
            />
          </div>

          <div className="w-[90%] max-w-[800px] mb-10">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="bg-[#1f2644] rounded-md px-6 py-4 text-white text-lg w-full font-kallisto focus:outline-none focus:ring-2 Kallisto_Bold"
            />
          </div>
        </div>

        <div className="w-4/5 sm:w-2/3 mx-auto flex justify-center">
          <button
            onClick={() =>
              handleSubmit({
                firstName,
                lastName,
                username,
              })
            }
            className="bg-[#3F50F6] hover:bg-[#2d3fcc] py-4 px-12 rounded flex items-center justify-center w-full sm:w-[250px] gap-4"
          >
            <span className="text-white Kallisto_Bold font-bold whitespace-nowrap">
              Confirm
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default NoUser;
